import { render, staticRenderFns } from "./SocialEntityCreate.vue?vue&type=template&id=edecde20&"
import script from "./SocialEntityCreate.js?vue&type=script&lang=js&"
export * from "./SocialEntityCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports